(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["femplus-page"]) return;
  try {
    
document.querySelector('[data-fem-print]')?.addEventListener('click',()=>window.print());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["femplus-product-faq"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('#fem-product-faq .ffq__btn').forEach(button=>button.addEventListener('click',()=>{

 const item=button.closest('.ffq__item');const open=!item.classList.contains('open');

 item.closest('.ffq__grid').querySelectorAll('.ffq__item').forEach(other=>{

  const active=other===item&&open;other.classList.toggle('open',active);

  other.querySelector('button').setAttribute('aria-expanded',String(active));

  other.querySelector('.ffq__body').hidden=!active;

 });

}));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["femplus-product-ingredients"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('vd-ingredients').forEach(section=>{

  section.querySelectorAll('[data-ingredient]').forEach(button=>button.addEventListener('click',()=>{

    section.querySelectorAll('[data-ingredient]').forEach(other=>{

      const active=other===button;

      other.classList.toggle('is-active',active);

      other.setAttribute('aria-pressed',String(active));

    });

    section.querySelectorAll('[data-ingredient-panel]').forEach(panel=>{

      panel.hidden=panel.dataset.ingredientPanel!==button.dataset.ingredient;

    });

  }));

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["femplus-product-main"]) return;
  try {
    

document.querySelectorAll('.fem-accordion button').forEach(button=>button.addEventListener('click',()=>{

 const open=button.getAttribute('aria-expanded')!=='true';

 document.querySelectorAll('.fem-accordion button').forEach(other=>{

  const active=other===button&&open;other.setAttribute('aria-expanded',String(active));

  const panel=document.getElementById(other.getAttribute('aria-controls'));panel.inert=!active;panel.setAttribute('aria-hidden',String(!active));

 });

}));

const femZoom=document.querySelector('.fem-zoom');

document.querySelector('.fem-zoom-trigger')?.addEventListener('click',()=>{

 const main=document.querySelector('#fem-main-image');const image=femZoom.querySelector('img');

 image.src=main.src;image.alt=main.alt;femZoom.showModal();

});

femZoom?.querySelector('button').addEventListener('click',()=>femZoom.close());

femZoom?.addEventListener('click',event=>{if(event.target===femZoom)femZoom.close();});



const femThumbs=Array.from(document.querySelectorAll('[data-fem-image]'));

const femStage=document.querySelector('.fem-gallery-stage');

let femSwipeStart=null, femSwipeUntil=0;

function selectFemImage(index){

 const button=femThumbs[(index+femThumbs.length)%femThumbs.length];

 const main=document.querySelector('#fem-main-image');main.src=button.dataset.femImage;main.alt=button.dataset.femAlt;

 femThumbs.forEach(other=>other.setAttribute('aria-pressed',String(other===button)));

 const row=button.parentElement;row.scrollTo({left:button.offsetLeft-row.offsetLeft-(row.clientWidth-button.clientWidth)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});

}

femThumbs.forEach((button,index)=>button.addEventListener('click',()=>selectFemImage(index)));

femStage.addEventListener('pointerdown',event=>{if(!event.isPrimary)return;femSwipeStart={x:event.clientX,y:event.clientY};});

femStage.addEventListener('pointerup',event=>{

 if(!femSwipeStart)return;

 const dx=event.clientX-femSwipeStart.x,dy=event.clientY-femSwipeStart.y;femSwipeStart=null;

 if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)*1.3){femSwipeUntil=Date.now()+500;selectFemImage(femThumbs.findIndex(button=>button.getAttribute('aria-pressed')==='true')+(dx<0?1:-1));}

});

femStage.addEventListener('pointercancel',()=>{femSwipeStart=null;});

femStage.addEventListener('click',event=>{if(Date.now()<femSwipeUntil){event.preventDefault();event.stopImmediatePropagation();}},true);

femStage.addEventListener('dragstart',event=>event.preventDefault());

femStage.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();selectFemImage(femThumbs.findIndex(button=>button.getAttribute('aria-pressed')==='true')+(event.key==='ArrowRight'?1:-1));}});

const femForm=document.querySelector('#fem-product-form');

const femSticky=document.querySelector('.fem-product-sticky');

const femStickyButton=femSticky?.querySelector('[type="submit"]');

const femPicker=femSticky?.querySelector('.fem-bundle-picker');

const syncPicker=()=>{

 const id=femForm.querySelector('input[name="id"]:checked')?.value;

 femPicker.querySelectorAll('[data-pick-variant]').forEach(option=>{

  const active=option.dataset.pickVariant===id;option.setAttribute('aria-pressed',String(active));

  if(active){femSticky.querySelector('[data-sticky-images]').replaceChildren(...Array.from(option.querySelector('.fem-picker-images').children,child=>child.cloneNode(true)));femSticky.querySelector('[data-sticky-kit]').textContent=option.querySelector('strong').textContent;femSticky.querySelector('[data-sticky-price]').textContent=option.querySelector('b').textContent;}

 });

};

femPicker?.querySelectorAll('[data-pick-variant]').forEach(option=>option.addEventListener('click',()=>{

 const input=Array.from(femForm.querySelectorAll('input[name="id"]')).find(input=>input.value===option.dataset.pickVariant);if(!input)return;input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));femPicker.open=false;femPicker.querySelector('summary').focus();

}));

if(femPicker){syncPicker();document.addEventListener('click',event=>{if(!femPicker.contains(event.target))femPicker.open=false;});femPicker.addEventListener('keydown',event=>{if(event.key==='Escape'){femPicker.open=false;femPicker.querySelector('summary').focus();}});}

if(femForm&&femSticky){

 const updateSticky=()=>{femSticky.hidden=femForm.getBoundingClientRect().bottom>0;};

 window.addEventListener('scroll',updateSticky,{passive:true});

 window.addEventListener('resize',updateSticky);updateSticky();

}

femForm?.querySelectorAll('input[name="id"]').forEach(input=>input.addEventListener('change',()=>{

 const button=femForm.querySelector('[type="submit"]');const available=input.dataset.available==='true';

 button.disabled=!available;button.textContent=available?'Aggiungi al carrello':'Esaurito';document.querySelector('.fem-stock-status').hidden=!available;

 if(femSticky){

  syncPicker();

  femSticky.querySelector('[data-sticky-price]').textContent=input.closest('.fem-kit').querySelector('.fem-kit-price').childNodes[0].textContent.trim();

  femStickyButton.disabled=!available;femStickyButton.textContent=button.textContent;

 }

 const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);

}));

femForm?.addEventListener('submit',async event=>{

 event.preventDefault();const button=femForm.querySelector('[type="submit"]');const error=femForm.querySelector('.fem-cart-error');

 const selected=femForm.querySelector('input[name="id"]:checked');if(!selected||selected.dataset.available!=='true')return;

 button.disabled=true;button.textContent='Aggiunta in corso…';error.hidden=true;

 if(femStickyButton){femStickyButton.disabled=true;femStickyButton.textContent=button.textContent;}

 try{

  const root=window.Shopify?.routes?.root||'/';

  const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:selected.value,quantity:1},{id:59668801225036,quantity:1,properties:{'In omaggio con':'Kit Donna+'}}]})});

  if(!response.ok)throw new Error('Impossibile aggiungere il kit. Riprova tra poco.');

  if(window.femCart){await window.femCart.open();}else{window.location.assign(root+'cart');}

  button.disabled=false;button.textContent='Aggiungi al carrello';if(femStickyButton){femStickyButton.disabled=false;femStickyButton.textContent=button.textContent;}

 }catch(e){error.textContent=e.message||'Si è verificato un errore. Riprova.';error.hidden=false;button.disabled=false;button.textContent='Aggiungi al carrello';if(femStickyButton){femStickyButton.disabled=false;femStickyButton.textContent=button.textContent;}error.scrollIntoView({block:'center',behavior:'smooth'});}

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
